export function useDynamicWebContentQueryParams({
  content_preview_overrides,
  pageType,
  preview_mode
}) {
  const queryArgs = {
    pageType
  };
  if (preview_mode) {
    queryArgs.isContentPreviewEnabled = true;
    if (content_preview_overrides && typeof content_preview_overrides === 'string') {
      queryArgs.contentPreviewOverrides = content_preview_overrides === null || content_preview_overrides === void 0 ? void 0 : content_preview_overrides.split(';');
    }
  }
  return queryArgs;
}
//# sourceMappingURL=useDynamicWebContentQueryParams.js.map